import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController
} from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { AppConfigProvider } from '../../providers/app-config/app-config';

/**
 * Generated class for the ForgotpwdPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-forgotpwd',
  templateUrl: 'forgotpwd.html'
})
export class ForgotpwdPage {
  email: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private http: HttpClient,
    private alertCtrl: AlertController,
    private appConfig: AppConfigProvider
  ) {}

  reset() {
    this.http
      .post(this.appConfig.apiUrl() + 'index.php/api/login/reset', {
        email: this.email,
        app_key: this.appConfig.appKey()
      })
      .subscribe(
        (res: any) => {
          if (res.status == 'success') {
            let alert = this.alertCtrl.create({
              title: 'Success',
              subTitle: 'Password has been reset. Please check your email.',
              buttons: ['Dismiss']
            });
            alert.present();
          } else {
            console.log('login failed.invalid user');
          }
        },
        err => {}
      );
  }
}



// WEBPACK FOOTER //
// ./src/pages/forgotpwd/forgotpwd.ts